import { createAction, createReducer } from '@reduxjs/toolkit';
import { today } from '../../../../../utils/dates';
import { IAction, IInitialState } from './interface';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,

  partner: 'todos',
  value: {
    from: 0,
    to: 9999999999,
  },
  dateFrom: '2020-01-01',
  dateTo: today(),

  time: {
    from: '0:0:0',
    to: '0:0:0',
  },
  credt: {
    name: '',
    cpfcnpj: '',
    agency: '',
    account: '',
    digit: '',
    typeAccount: '',
  },
  debt: {
    name: '',
    cpfcnpj: '',
    agency: '',
    account: '',
    digit: '',
    typeAccount: '',
  },
  type_transaction: '',
  idTransaction: '',
  codLegado: '',
  status: '',
};

export const settingFilter = createAction(
  '@transfersApp/filter/SETTING_FILTER'
);

export const setPartnerFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_PARTNER_FILTER_OPTION'
);
export const setFinalDateFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_FINAL_DATE_FILTER_OPTION'
);
export const setInitialDateFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_INITIAL_DATE_FILTER_OPTION'
);
export const setTypeTransactionOptions = createAction<any>(
  '@transfersApp/filter/SET_TYPE_OPTION_FILTER_OPTION'
);
export const setFinalValueFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_FINAL_VALUE_FILTER_OPTION'
);
export const setFinalPeriodFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_FINAL_PERIOD_FILTER_OPTION'
);
export const setInitialPeriodFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_INITIAL_PERIOD_FILTER_OPTION'
);
export const setInitialValueFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_INITIAL_VALUE_FILTER_OPTION'
);
export const setNameCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_NAME_CREDT_FILTER_OPTION'
);
export const setNameDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_NAME_DEBT_FILTER_OPTION'
);
export const setCnpjcpfCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_CNPJCPF_CREDT_FILTER_OPTION'
);
export const setCnpjcpfDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_CNPJCPF_DEBT_FILTER_OPTION'
);
export const setAgencyCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_AGENCY_CREDT_FILTER_OPTION'
);
export const setAgencyDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_AGENCY_DEBT_FILTER_OPTION'
);
export const setAccountCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_ACCOUNT_CREDT_FILTER_OPTION'
);
export const setAccountDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_ACCOUNT_DEBT_FILTER_OPTION'
);
export const setDigitCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_DIGIT_CREDT_FILTER_OPTION'
);
export const setDigitDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_DIGIT_DEBT_FILTER_OPTION'
);
export const setTypeAccountCredtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_TYPEACCOUNT_CREDT_FILTER_OPTION'
);
export const setTypeAccountDebtFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_TYPEACCOUNT_DEBT_FILTER_OPTION'
);
export const setCodLegFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_CODLEGADO_FILTER_OPTION'
);
export const setIdTransacaoFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_ID_TRANSACAO_FILTER_OPTION'
);
export const setSituationFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_SITUACAO_FILTER_OPTION'
);

export const setSearched = createAction<any>(
  '@transfersApp/filter/SET_SEARCHED'
);

export const gotError = createAction('@transfersApp/filter/GOT_ERROR');

const transfersFilterReducer = createReducer(INITIAL_STATE, {
  [settingFilter.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [setPartnerFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    partner: action.payload,
  }),
  [setCodLegFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    codLegado: action.payload.codLegado,
  }),
  [setFinalDateFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    dateTo: action.payload.dateTo,
  }),
  [setInitialDateFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    dateFrom: action.payload.dateFrom,
  }),
  [setSituationFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    status: action.payload.status,
  }),
  [setTypeTransactionOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    type_transaction: action.payload.type_transaction,
  }),
  [setFinalValueFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    value: { ...state.value, to: action.payload.value.to },
  }),
  [setInitialValueFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    value: {
      ...state.value,
      from: action.payload.value.from,
    },
  }),
  [setIdTransacaoFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    idTransaction: action.payload.idTransaction,
  }),
  [setInitialPeriodFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    time: {
      ...state.time,
      from: action.payload.time.from,
    },
  }),
  [setFinalPeriodFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    time: {
      ...state.time,
      to: action.payload.time.to,
    },
  }),
  [setNameCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, name: action.payload.credt.name },
  }),
  [setNameDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, name: action.payload.debt.name },
  }),
  [setCnpjcpfCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, cpfcnpj: action.payload.credt.cpfcnpj },
  }),
  [setCnpjcpfDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, cpfcnpj: action.payload.debt.cpfcnpj },
  }),
  [setAgencyDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, agency: action.payload.debt.agency },
  }),
  [setAgencyCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, agency: action.payload.credt.agency },
  }),
  [setDigitCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, digit: action.payload.credt.digit },
  }),
  [setDigitDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, digit: action.payload.debt.digit },
  }),
  [setTypeAccountCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, typeAccount: action.payload.credt.typeAccount },
  }),
  [setTypeAccountDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, typeAccount: action.payload.debt.typeAccount },
  }),
  [setAccountCredtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credt: { ...state.credt, account: action.payload.credt.account },
  }),
  [setAccountDebtFilterOptions.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    debt: { ...state.debt, account: action.payload.debt.account },
  }),
  [setSearched.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    partner: action.payload.partner,
    value: {
      from: action.payload.value.from,
      to: action.payload.value.to,
    },
    dateTo: action.payload.date.to,
    dataFrom: action.payload.date.from,
    time: {
      from: action.payload.time.from,
      to: action.payload.time.to,
    },
    credt: {
      name: action.payload.credt.name,
      cpfcnpj: action.payload.credt.cpfcnpj,
      agency: action.payload.credt.agency,
      account: action.payload.credt.account,
      digit: action.payload.credt.digit,
      typeAccount: action.payload.credt.typeAccount,
    },
    debt: {
      name: action.payload.debt.name,
      cpfcnpj: action.payload.debt.cpfcnpj,
      agency: action.payload.debt.agency,
      account: action.payload.debt.account,
      digit: action.payload.debt.digit,
      typeAccount: action.payload.debt.typeAccount,
    },
    type_transaction: action.payload.type_transaction,
    idTransaction: action.payload.idTransaction,
    codLegado: action.payload.codLegado,
  }),
  [gotError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default transfersFilterReducer;
